import { createApp } from 'vue';
import { createPinia } from 'pinia'

import FavoritesHeader from '../components/FavoritesHeader.vue';

export default function loadFavoritesHeader(el) {
    createApp(FavoritesHeader).use(createPinia()).mount(el);
}